<button class="btn btn-info mb-2" (click)="confirmRestoreRecommendedAllClusters()">
  Synchroniser les paramètres recommandés sur tous les clusters
</button>

@if (paramGroups) {
  <app-brain-parameters
    [paramGroups]="paramGroups"
    [brainOverrides]="{}"
    [showVisibility]="true"
    [showUids]="true"
    [enableFilterOverrides]="false"
  />
}
